import { useContext } from "react";
import {
  IDispatchAddNotif,
  IDispatchClearNotif,
  INotificationMessage,
} from "../../components/Notifications/Notification.interface";
import { NotificationContext } from "../../components/Notifications/NotificationProvider";
import { ADD_NOTIFICATION, RESET } from "../../components/shared/constant";

export const useNotification = () => {
  const dispatch = useContext(NotificationContext);

  const addNotification = (props: INotificationMessage): React.Dispatch<IDispatchAddNotif> => {
    return dispatch({
      type: ADD_NOTIFICATION,
      payload: {
        id: self.crypto.randomUUID(), // random id for key in .map for multiple notifs
        ...props,
      },
    });
  };

  const clearNotificationState = (): React.Dispatch<IDispatchClearNotif> => {
    return dispatch({ type: RESET });
  };

  return { addNotification, clearNotificationState };
};
